/**
 *  配电终端管理
 */
import * as HttpService from "../../../../service/HttpService";
/**
 * 获取下载模板
 */
export const getTerminalTemplate = () => {
    return HttpService.get(HttpService.DOMAIN + "/distributionTerminal/getTerminalTemplate");
};

/**
 * 获取终端型号下拉列表
 */
export const getTerminalTypes = (flag) => {
    return HttpService.get(HttpService.DOMAIN + "/distributionTerminal/getTerminalTypes?flag="+flag);
};

/**
 * 查询用电单位
 */
export const queryElectricityUnit = (userFlag) => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/unitList?userFlag="+userFlag);
};

/**
 * 查询用电单位(返回结果没有全部)
 */
export const queryElectricityUnitOnAdd = (userFlag) => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/uintListOnAdd?userFlag="+userFlag);
};

/**
 * 查询终端型号
 */
export const getTermModelCode = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/queryTermCode",params);
};

/**
 * 获取通讯规约（厚强）
 */
export const getTermCommProtoList = () => {
    return HttpService.get(HttpService.DOMAIN + "/terminalFiles/getTermCommProtoList");
};

/**
 * 获取生产厂家（厚强）
 */
export const getTermModalMfrCodeList = () => {
    return HttpService.get(HttpService.DOMAIN + "/terminalFiles/getTermModalMfrCodeList");
};

/**
 * 根据用电单位查询配电房
 * @param unitId 用电单位Id
 */
export const queryDistributionByUnitId = (unitId) => {
    return HttpService.get(HttpService.DOMAIN + "/distributionTerminal/queryDistributionByUnitId?unitId="+unitId);
};

/**
 * 查询终端管理列表
 */
export const queryTerminalList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/terminalList",params);
};

/**
 * 新增终端
 */
export const addTerminal = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/addTerminal", params);
};

/**
 * 编辑终端
 */
export const editTerminal = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/editTerminal", params);
};

/**
 * 编辑前根据ID获取详情
 */
export const getTerminalByTermId = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/distributionTerminal/getTerminalByTermId?termIds="+params);
};

/**
 *  删除终端
 */
export const deleteTerminal = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/deleteTerminal",params);
};

/**
 *  批量导入新增
 */
export const bulkAdd = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/bulkAdd",params);
};

/**
 * 批量导入终端模板
 */
export const bulkImportTerminal = () => {
    return HttpService.post(HttpService.DOMAIN + "/meterFiles/getMeasPointId");
};

/**
 *  查询code表
 */
export const queryCode = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionTerminal/queryCode",params);
};

